import { render, staticRenderFns } from "./InsurerUsersPage.vue?vue&type=template&id=72836536&"
import script from "./InsurerUsersPage.vue?vue&type=script&lang=js&"
export * from "./InsurerUsersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports